import { Fragment, FunctionComponent } from 'react';
import { Col, Row } from 'react-styled-flexboxgrid';

import {
  Card,
  CardSeparator,
} from '@savgroup-front-common/core/atoms/Cards';
import { Heading } from '@savgroup-front-common/core/atoms/Heading';
import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import {
  FileSparePartRequestLine,
  REQUEST_LINE_STATUS,
} from '@savgroup-front-common/types';

import { DeliveredSpareParts } from './DeliveredSparePart';
import messages from './DeliveredSparePart/messages';
import { useGetRequestines } from './DeliveredSparePartsList.hooks';
import DeliveredSparePartsListModal from './DeliveredSparePartsListModal';

interface DeliveredSparePartsListType {
  fileId: string;
}

const DeliveredSparePartsList: FunctionComponent<
  DeliveredSparePartsListType
> = ({ fileId }) => {
  const {
    isOpenModal,
    handleCloseModal,
    requestLines,
    handleRequestLineStatusUpdate,
    handleSetCurrentRequestLine,
    currentRequestLine,
  } = useGetRequestines({ fileId });

  const isVisibleRequestLine =
    !!requestLines &&
    requestLines.some(
      (line: FileSparePartRequestLine) =>
        line.requestLineStatus === REQUEST_LINE_STATUS.TO_PROCESS ||
        line.requestLineStatus === REQUEST_LINE_STATUS.ORDER_DELIVERED ||
        line.requestLineStatus === REQUEST_LINE_STATUS.ORDER_SUBMITTED ||
        line.requestLineStatus === REQUEST_LINE_STATUS.ORDER_SHIPPED,
    );

  return (
    <>
      {isVisibleRequestLine && (
        <Card>
          <Heading level={2}>
            <SafeFormattedMessageWithoutSpread message={messages.title} />
          </Heading>
          <Row>
            <Col xs={12}>
              <SafeFormattedMessageWithoutSpread
                message={messages.description}
              />
            </Col>
          </Row>
          {requestLines.map((requestLine) => (
            <Fragment key={requestLine.sparePartReference}>
              <CardSeparator />

              <DeliveredSpareParts
                requestLine={requestLine}
                onChange={() => {
                  handleSetCurrentRequestLine(requestLine.requestLineId);
                }}
              />
            </Fragment>
          ))}

          <DeliveredSparePartsListModal
            isOpen={isOpenModal}
            onClose={handleCloseModal}
            currentRequestLine={currentRequestLine}
            onValidate={handleRequestLineStatusUpdate}
          />
        </Card>
      )}
    </>
  );
};

export default DeliveredSparePartsList;
